module.exports = __webpack_public_path__ + "img/ListView.94bd28e1.svg";